export default "__VITE_ASSET__DGstcG33__"